import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "df-payment__recurring",
    role: "note"
};
const _hoisted_2 = {
    key: 1,
    class: "df-payment__error",
    role: "alert"
};
const _hoisted_3 = { class: "df-payment__actions" };
const _hoisted_4 = {
    class: "df-sr-only",
    role: "status"
};
const _hoisted_5 = ["aria-label"];
const _hoisted_6 = { class: "df-payment__note" };
import { computed, inject, ref } from "vue";
import { useDonation } from "../context/donationContext";
import { SubmitErrorKey } from "../context/submitError";
import { useChrome } from "../i18n/useChrome";
import StepShell from "../components/layout/StepShell.vue";
import OrderSummary from "../components/payment/OrderSummary.vue";
import BaseButton from "../components/ui/BaseButton.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'StepPayment',
    setup(__props) {
        // SYNC: see ../_SYNC.md.
        const { amountMinor, formatMinor, frequency, frequencySuffixToken, isRecurring, canProceed, previewMode, status, back, submit, simulateOutcome, } = useDonation();
        const { tf } = useChrome();
        const submitError = inject(SubmitErrorKey, computed(() => null));
        const isSubmitting = computed(() => status.value === "submitting");
        const suffix = computed(() => frequencySuffixToken.value ? ` ${tf(`frequency.suffix.${frequency.value}`)}` : "");
        const donateLabel = computed(() => `${tf("actions.donate")} ${formatMinor(amountMinor.value)}${suffix.value}`);
        const buttonLabel = computed(() => isSubmitting.value ? tf("payment.submitting") : donateLabel.value);
        const showOutcomePicker = ref(false);
        const PREVIEW_OUTCOMES = [
            { type: "ThankYou", labelKey: "success" },
            { type: "PaymentFailed", labelKey: "failure" },
            { type: "Cancelled", labelKey: "cancelled" },
            { type: "Pending", labelKey: "pending" },
        ];
        function onPrimaryClick() {
            if (previewMode.value) {
                showOutcomePicker.value = !showOutcomePicker.value;
                return;
            }
            submit();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(StepShell, {
                title: _unref(tf)('payment.title'),
                subtitle: _unref(tf)('payment.subtitle')
            }, {
                default: _withCtx(() => [
                    _createVNode(OrderSummary, { class: "df-payment__summary" }),
                    (_unref(isRecurring) && !_unref(previewMode))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(tf)("payment.recurringNote")), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    (_unref(submitError))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(submitError)), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(BaseButton, {
                            variant: "ghost",
                            type: "button",
                            disabled: isSubmitting.value,
                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(back)()))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(tf)("actions.back")), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["disabled"]),
                        _createVNode(BaseButton, {
                            variant: "primary",
                            block: "",
                            type: "button",
                            disabled: !_unref(canProceed) || isSubmitting.value,
                            "aria-busy": isSubmitting.value ? 'true' : undefined,
                            "aria-expanded": _unref(previewMode) ? showOutcomePicker.value : undefined,
                            onClick: onPrimaryClick
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(buttonLabel.value), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["disabled", "aria-busy", "aria-expanded"])
                    ]),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(isSubmitting.value ? _unref(tf)("payment.submitting") : ""), 1 /* TEXT */),
                    (_unref(previewMode) && showOutcomePicker.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "df-payment__preview-outcomes",
                            role: "group",
                            "aria-label": _unref(tf)('payment.previewOutcomesLabel')
                        }, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(PREVIEW_OUTCOMES, (o) => {
                                return _createVNode(BaseButton, {
                                    key: o.type,
                                    variant: "ghost",
                                    type: "button",
                                    onClick: ($event) => (_unref(simulateOutcome)(o.type))
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(tf)(`payment.previewOutcome.${o.labelKey}`)), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]);
                            }), 64 /* STABLE_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_5))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(previewMode) ? _unref(tf)("payment.previewNote") : _unref(tf)("payment.redirectNote")), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "subtitle"]));
        };
    }
});
